/**
 * Feature flags configuration
 *
 * Environment variables must be prefixed with NEXT_PUBLIC_ to be available on client-side.
 * Values are evaluated at build-time.
 *
 * Usage:
 *   import { features } from '@/lib/config/features';
 *   if (features.store) { ... }
 */

export const features = {
  /** Enable/disable staging features (STUDIO, STORE links, COLLECTOR ACCESS, SIGN IN) */
  stage: process.env.NEXT_PUBLIC_FEATURE_STAGE === 'true',
  /** Enable/disable store functionality (cart, purchase buttons, prices) */
  store: process.env.NEXT_PUBLIC_FEATURE_STORE === 'true',
  /** Enable/disable collector rewards functionality (upcoming release) */
  collectorRewards: process.env.NEXT_PUBLIC_FEATURE_COLLECTOR_REWARDS === 'true',
  /** Enable/disable collector commissions functionality (upcoming release) */
  collectorCommissions: process.env.NEXT_PUBLIC_FEATURE_COLLECTOR_COMMISSIONS === 'true',
  /** Enable/disable upcoming releases section (upcoming release) */
  upcomingReleases: process.env.NEXT_PUBLIC_FEATURE_UPCOMING_RELEASES === 'true',
} as const;

export type FeatureKey = keyof typeof features;

/**
 * Helper to check if a feature is enabled
 */
export function isFeatureEnabled(key: FeatureKey): boolean {
  return features[key];
}
